import {useEffect, useRef, useState} from "react";
import {getEmailCounts, markEmailVisit} from "./apiClient";
import {useDataRefresh} from "./useData";

export function useMailboxCounts() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const baseline = useRef(undefined);
  const alive = useRef(true);
  const busy = useRef(false);
  const load = async () => {
    if (busy.current || document.visibilityState === "hidden") return;
    busy.current = true;
    try {
      const result = await getEmailCounts(baseline.current);
      if (!alive.current) return;
      if (baseline.current === undefined) baseline.current = result.seen_since || "";
      setData(result); setError(false);
      // Only the in-app visit marker changes; Gmail read state is untouched.
      await markEmailVisit(result.snapshot_at);
    } catch { if (alive.current) setError(true); }
    finally {busy.current = false;}
  };
  useDataRefresh(load, ["emails"]);
  useEffect(() => {
    alive.current = true; load();
    const timer = window.setInterval(load, 60000);
    document.addEventListener("visibilitychange", load);
    return () => {alive.current = false; window.clearInterval(timer); document.removeEventListener("visibilitychange", load);};
    // The previous-visit baseline deliberately stays fixed for this open page.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {data, error};
}
